import axios from 'axios'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  headers: { 'Content-Type': 'application/json' },
})

// ── Request interceptor: headers dinámicos en cada request ──
api.interceptors.request.use((config) => {
  // Token JWT (access token)
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  // ID token (Cognito) — usado por el backend para resolver email sin llamar a GetUser
  const idToken = localStorage.getItem('id_token')
  if (idToken) {
    config.headers['x-id-token'] = idToken
  }

  // Simulación de usuario (testing — solo HoE)
  const simUserRaw = sessionStorage.getItem('simulate_user')
  if (simUserRaw) {
    try {
      const { id } = JSON.parse(simUserRaw)
      if (id) {
        config.headers['x-simulate-user-id'] = id
      }
    } catch { /* silent */ }
  }

  // Dev bypass (local)
  if (import.meta.env.DEV) {
    const devOverrideRaw = sessionStorage.getItem('dev_user_override')
    if (devOverrideRaw) {
      try {
        const { id, role } = JSON.parse(devOverrideRaw)
        if (id)  config.headers['x-dev-user-id'] = id
        if (role) config.headers['x-dev-role']    = role
      } catch { /* silent */ }
    } else if (import.meta.env.VITE_DEV_USER_ID) {
      config.headers['x-dev-user-id'] = import.meta.env.VITE_DEV_USER_ID
      config.headers['x-dev-role']    = import.meta.env.VITE_DEV_ROLE ?? 'developer_leader'
    }
  }

  return config
})

// ── Response interceptor: 401 → login ──
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('id_token')
      sessionStorage.removeItem('simulate_user')
      sessionStorage.removeItem('dev_user_override')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Helpers para compatibilidad con código existente
export function setDevUser(userId: string, role: string) {
  if (import.meta.env.DEV) {
    sessionStorage.setItem('dev_user_override', JSON.stringify({ id: userId, role }))
  }
}
export function setDevRole(role: string) {
  if (import.meta.env.DEV) {
    const raw = sessionStorage.getItem('dev_user_override')
    const current = raw ? JSON.parse(raw) : {}
    sessionStorage.setItem('dev_user_override', JSON.stringify({ ...current, role }))
  }
}
